var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title-write",style:({opacity:0}),attrs:{"id":"title-bg"}}),_c('div',{staticClass:"bar"},[_c('img',{staticClass:"back",attrs:{"src":require("../../assets/images/member_new/back.png")},on:{"click":_vm.goBack}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }